export default class moreInfoFooterForm
{
    constructor()
    {
        this.el = '#moreInfoFooterForm';

        if (!$(this.el).length) {
            return;
        }

        this.data = {
            input: {
                type: '',
                email: '',
            },
            serverError: '',
            successfulServerResponse: '',
            status: '',
            verified: false,
        };

        this._initVue();
    }

    _initVue()
    {
        let footerFormInst = new Vue({
            el: this.el,
            data: this.data,
            methods: {
                onCaptchaVerified (recaptchaToken) {

                    this.status = "submitting";
                    this.$refs.recaptcha.reset();

                    axios.post(window.location.origin + '/more_info', {
                        type:  this.input.type,
                        email: this.input.email,
                        recaptchaToken: recaptchaToken
                    }).then(response => {
                        let $successMsg = $(this.$el).find('.success-js');
                        this.sucessfulServerResponse = response.data.message;
                        this.verified = false;

                        $successMsg.removeClass('hidden');

                        setTimeout(() => {
                            $successMsg.focus();
                        }, 200);

                        setTimeout(() => {
                            $successMsg.addClass('hidden');
                        }, 3000);
                    }).catch(err => {
                        this.verified = false;
                        console.error(err);
                    });
                },

                onCaptchaExpired () {

                    console.log('captcha expired' );

                    this.$refs.recaptcha.reset();
                },

                isABot () {
                    console.log('isABot');
                },

                submitForm() {
                    this.$validator.validateAll().then(response => {
                        if (response) {
                            this.verified = true;
                        } else {
                            this.verified = false;
                        }
                    });
                },
            },
        });
    }
}

